import { render, staticRenderFns } from "./RemoveRecordModal.vue?vue&type=template&id=1bc9d2f6&"
import script from "./RemoveRecordModal.vue?vue&type=script&lang=js&"
export * from "./RemoveRecordModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveRecordModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports